import MobileModalFrame from "../../common-components/mobile-modal-frame";
import { useTranslation as useInterfaceTranslation } from "react-i18next";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import CrossIcon from "../../../assets/img/order-details/cross.svg";
import { sendEmailData } from "Services/order-pdf";
import { timeout_secs } from "Constants/alert-modal";

import "./index.scss";

function SendbyMail({ ...props }: any) {
  const { t: uiT } = useInterfaceTranslation("interface");
  const {
    documentUrl,
    orderId,
    userData,
    setResponseMsgModalShow,
    setResponseStatus,
    setResponseMsg,
    setShareStatestoInitial,
    setDocumentUrl,
    changeRouteOnshare,
  } = props;

  const { t } = useTranslation(["emailOrder"]);

  const [mail, setMail] = useState("");
  const [note, setNote] = useState("");
  const [loader, setLoader] = useState(false);

  const onSubmitHandler = (event: any) => {
    event.preventDefault();

    if (loader) return;

    setLoader(true);

    const data = {
      order: orderId,
      user: userData.id,
      document_url: documentUrl,
      receipient_email: mail.trim(),

      // שיתוף רגיל
      receipient_type: 3,
      supplier_name: "",
      is_esisting_customer: false,

      notes: note.trim(),
    };

    sendEmailData(data)
      .then(() => {
        setLoader(false);
        setMail("");
        setNote("");

        props.onHide();
        setShareStatestoInitial();
        setDocumentUrl("");

        setResponseStatus({
          msg: t("order sent", {
            ns: "emailOrder",
          }),
          color: "#00B38F",
        });

        setResponseMsg({
          msg: t("receive private email", {
            ns: "emailOrder",
          }),
          color: "#2C3341",
        });

        setResponseMsgModalShow(true);

        setTimeout(() => {
          setResponseMsgModalShow(false);
          changeRouteOnshare();
        }, timeout_secs);
      })
      .catch((err) => {
        console.error("Email sharing failed:", err);

        setLoader(false);

        setResponseStatus({
          msg: t("order not sent", {
            ns: "emailOrder",
          }),
          color: "#CD2017",
        });

        setResponseMsg({
          msg:
            err?.response?.data?.detail ||
            t("email not recieved", {
              ns: "emailOrder",
            }),
          color: "#2C3341",
        });

        setResponseMsgModalShow(true);

        setTimeout(() => {
          setResponseMsgModalShow(false);
        }, timeout_secs);
      });
  };

  const handleClose = () => {
    if (loader) return;

    setMail("");
    setNote("");
    props.onHide();
  };

  return (
    <Modal
      {...props}
      onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="project-modal"
      backdrop={loader ? "static" : true}
      keyboard={!loader}
    >
<MobileModalFrame onClose={handleClose}>
      <div className="head">
        <h4>
          {t("send by mail", {
            ns: "emailOrder",
          })}
        </h4>

        {!loader && (
          <img
            src={CrossIcon}
            alt="cross"
            style={{ cursor: "pointer" }}
            onClick={handleClose}
          />
        )}
      </div>

      <form
        className="body"
        onSubmit={onSubmitHandler}
      >
        <h5 className="main-head"> {uiT("Recipient email")} </h5>

        <div className="custom-form-group">
          <input
            type="email"
            id="mail"
            placeholder="example@email.com"
            required
            value={mail}
            onChange={(event) =>
              setMail(event.target.value)
            }
          />
        </div>

        <h5 className="main-head"> {uiT("Notes")} </h5>

        <div className="custom-form-group">
          <textarea
            rows={5}
            id="note"
            placeholder={uiT("Optional email message")}
            value={note}
            onChange={(event) =>
              setNote(event.target.value)
            }
          />
        </div>

        <div className="save-wrapper">
          <button
            type="submit"
            className="save-btn"
            disabled={loader}
          >
            {loader && (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
                &nbsp;
              </>
            )}

            {loader ? "שולח..." : "שלח"}
          </button>
        </div>
      </form>
    </MobileModalFrame>
</Modal>
  );
}

export default SendbyMail;